<template>
  <div class="row">
    <div class="col-12">
      <el-table v-if="reports.length > 0" :data="reports">
        <el-table-column
          v-for="column in tableColumns"
          :key="column.label"
          :min-width="column.minWidth"
          :prop="column.prop"
          :label="column.label"
          :formatter="column.formatter"
        >
        </el-table-column>
      </el-table>
      <div v-show="reports.length === 0">신고 내역이 없습니다.</div>
    </div>
  </div>
</template>

<script>
import { formatDateTime } from "@/util/DateUtils";

export default {
  name: "ReportsForContentTableView",
  components: {},
  data() {
    return {
      tableColumns: [
        {
          prop: "id",
          label: "신고 ID",
          minWidth: 70,
        },
        {
          formatter: (row) => row.types.map((type) => type.name).join(", "),
          label: "구분",
          minWidth: 250,
        },
        {
          prop: "etcDesc",
          label: "기타 신고내용",
          minWidth: 200,
        },
        {
          prop: "stateName",
          label: "상태",
          minWidth: 80,
        },
        {
          formatter: (row) => formatDateTime(row.regTime),
          label: "신고 날짜",
          minWidth: 160,
        },
      ],
    };
  },
  props: {
    reports: {
      type: Array,
      required: true,
    },
  },
};
</script>
